var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "vs-row",
        [
          _c(
            "vs-col",
            { attrs: { "vs-w": "12" } },
            [
              _c(
                "vs-divider",
                { staticClass: "mt-20 font-bold", attrs: { position: "left" } },
                [_c("p", { staticClass: "bold" }, [_vm._v("Destinataires(s)")])]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "vx-row mb-6" }, [
                _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                  _c("span", [_vm._v("Service(s) :")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full" },
                  _vm._l(_vm.resource.services, function (service, j) {
                    return _c("span", { key: j }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(service.title) +
                          "\n                    "
                      ),
                    ])
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "vs-divider",
                { staticClass: "mt-20 font-bold", attrs: { position: "left" } },
                [
                  _c("p", { staticClass: "bold" }, [
                    _vm._v("Périmètre valideur"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "vx-row mb-6" }, [
                _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                  _c("span", [_vm._v("Service du contributeur :")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full" },
                  _vm._l(
                    _vm.resource.contribution_services,
                    function (service, j) {
                      return _c("span", { key: j }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(service.title) +
                            "\n                    "
                        ),
                      ])
                    }
                  ),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vx-row mb-6" }, [
                _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                  _c("span", [_vm._v("Service du valideur :")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full" },
                  _vm._l(
                    _vm.resource.validation_services,
                    function (service, j) {
                      return _c("span", { key: j }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(service.title) +
                            "\n                    "
                        ),
                      ])
                    }
                  ),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "vs-divider",
                { staticClass: "mt-20 font-bold", attrs: { position: "left" } },
                [_c("p", { staticClass: "bold" }, [_vm._v("Contenu")])]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "vx-row mb-6" }, [
                _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                  _c("span", [_vm._v("Grille :")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full" },
                  _vm._l(_vm.resource.grids, function (grid, j) {
                    return _c(
                      "span",
                      { key: j },
                      [
                        _c("vs-chip", { attrs: { color: "primary" } }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(grid.title) +
                              "\n                        "
                          ),
                        ]),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vx-row mb-6" }, [
                _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                  _c("span", [_vm._v("Questionnaire(s) :")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full" },
                  [
                    _c("vs-chip", { attrs: { color: "primary" } }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.resource.rating_questionnaire.name) +
                          "\n                    "
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "vs-divider",
                { staticClass: "mt-20 font-bold", attrs: { position: "left" } },
                [_c("p", { staticClass: "bold" }, [_vm._v("Analyse")])]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "vx-row mb-6" }, [
                _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                  _c("span", [_vm._v("Question(s) d'analyse :")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full" },
                  [
                    _c("vs-chip", { attrs: { color: "primary" } }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.resource.campaign_questionnaire.name) +
                          "\n                    "
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "vs-divider",
                { staticClass: "mt-20 font-bold", attrs: { position: "left" } },
                [_c("p", { staticClass: "bold" }, [_vm._v("Séquence")])]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "vx-row mb-6" }, [
                _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                  _c("span", [_vm._v("Date 1er envoi :")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full" },
                  [
                    _c("vs-input", {
                      staticClass: "w-full",
                      attrs: {
                        type: "date",
                        name: "addCampaignFirstDate",
                        disabled: true,
                      },
                      model: {
                        value: _vm.resource.sent_date_1,
                        callback: function ($$v) {
                          _vm.$set(_vm.resource, "sent_date_1", $$v)
                        },
                        expression: "resource.sent_date_1",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vx-row mb-6" }, [
                _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                  _c("span", [_vm._v("Date 2eme envoi :")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full" },
                  [
                    _c("vs-input", {
                      staticClass: "w-full",
                      attrs: {
                        type: "date",
                        name: "addCampaignSecondDate",
                        disabled: true,
                      },
                      model: {
                        value: _vm.resource.sent_date_2,
                        callback: function ($$v) {
                          _vm.$set(_vm.resource, "sent_date_2", $$v)
                        },
                        expression: "resource.sent_date_2",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vx-row mb-6" }, [
                _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                  _c("span", [_vm._v("Date 3eme envoi :")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full" },
                  [
                    _c("vs-input", {
                      staticClass: "w-full",
                      attrs: {
                        type: "date",
                        name: "addCampaignThirdDate",
                        disabled: true,
                      },
                      model: {
                        value: _vm.resource.sent_date_3,
                        callback: function ($$v) {
                          _vm.$set(_vm.resource, "sent_date_3", $$v)
                        },
                        expression: "resource.sent_date_3",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }